module.exports = __webpack_public_path__ + "files/1a910d7cd0f832be213abeec6fab1d99.svg";